import { ajax } from '../index'

/**
 * 文章页接口
 */
export default {
  // 获取文章页内容
  getArticleContent(articleName: string) {
    return ajax.get("api", `/api/v1/article/${articleName}`, {});
  },
};
